// extracted by mini-css-extract-plugin
export default {"card":"style_card__SQ-56","container":"style_container__vRrNu","absolute":"style_absolute__BZeFk","videotitle":"style_videotitle__d7YCd"};